import React from 'react';
import * as AntIcons from '@ant-design/icons';
import styled, { css } from 'styled-components';
import { View, Tooltip, PopConfirm } from '@components';
import * as CustomIcons from './CustomIcons';
import IconMDI from '@mdi/react';
import * as IconsMDI from '@mdi/js';

const Font = AntIcons.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1608026_nedtdetu7nf.js',
});

const TypedIconsMDI = Object.entries(IconsMDI).map((item) => ({
  name: item[0]
    .slice(3)
    .split(/(?=[A-Z])/)
    .join('-')
    .toLowerCase(),
  path: item[1],
}));

const MDI = ({ type, ...otherProps }) => {
  const icon = TypedIconsMDI.find((icon) => icon.name === type);

  return icon ? <IconMDI {...otherProps} path={icon.path} /> : null;
};

MDI.defaultProps = {
  size: 1,
};

const handleIconTypes = (props) => {
  switch (props.type) {
    case 'selected':
      return css`
        color: #ffffff;
        background-color: #28a745;
      `;

    default:
      return css`
        color: ${(props) => (props.color ? props.color : '#595959')};
        background-color: ${(props) => (props.bgColor ? props.bgColor : '#ffffff')};
      `;
  }
};

const handleHoverIconTypes = (props) => {
  switch (props.type) {
    case 'add':
      return css`
        color: #ffffff;
        background-color: #28a745;
      `;

    case 'edit':
      return css`
        color: #ffffff;
        background-color: #40a9ff;
      `;

    case 'delete':
      return css`
        color: #ffffff;
        background-color: #dc3545;
      `;

    case 'detail':
      return css`
        color: #ffffff;
        background-color: #ff9637;
      `;

    case 'selected':
      return css`
        color: #ffffff;
        background-color: #28a745;
      `;

    default:
      return css`
        color: ${(props) => (props.hoverColor ? props.hoverColor : '#000000')};
        background-color: ${(props) => (props.hoverBgColor ? props.hoverBgColor : '#dddddd')};
      `;
  }
};

const Presets = styled(View)`
  width: ${(props) => (props.width ? props.width : '30px')};
  height: ${(props) => (props.width ? props.height : '30px')};
  display: flex;
  justify-content: center;
  border-radius: 20px;
  cursor: pointer;
  transition: 0.2s;
  ${(props) => handleIconTypes(props)}

  :hover {
    ${(props) => handleHoverIconTypes(props)}
  }
`;

const PresetIcon = (CustomIcon, { tooltipTitle, action, color, bgColor, hoverColor, hoverBgColor, type, ...otherProps }) => (
  <Tooltip title={tooltipTitle}>
    <Presets type={type} onClick={action} color={color} bgColor={bgColor} hoverColor={hoverColor} hoverBgColor={hoverBgColor}>
      <CustomIcon {...otherProps} />
    </Presets>
  </Tooltip>
);

const Add = ({ customIcon = AntIcons.PlusOutlined, tooltipTitle, action, ...otherProps }) =>
  PresetIcon(customIcon, { tooltipTitle: tooltipTitle ? tooltipTitle : 'Adicionar', action, type: 'add', ...otherProps });

const Selected = ({ tooltipTitle, action, ...otherProps }) =>
  PresetIcon(AntIcons.RightOutlined, {
    tooltipTitle: tooltipTitle ? tooltipTitle : 'Selecionado',
    action,
    type: 'selected',
    ...otherProps,
  });

const Edit = ({ customIcon = AntIcons.EditOutlined, tooltipTitle, action, ...otherProps }) =>
  PresetIcon(customIcon, { tooltipTitle: tooltipTitle ? tooltipTitle : 'Editar', action, type: 'edit', ...otherProps });

const Delete = ({ customIcon = AntIcons.DeleteOutlined, tooltipTitle, popConfirmTitle, action, ...otherProps }) => (
  <PopConfirm key="2" title={popConfirmTitle} onCancel={action}>
    {PresetIcon(customIcon, {
      tooltipTitle: tooltipTitle ? tooltipTitle : 'Excluir',
      action: undefined,
      type: 'delete',
      ...otherProps,
    })}
  </PopConfirm>
);

const Detail = ({ customIcon = AntIcons.RightOutlined, tooltipTitle, action, ...otherProps }) =>
  PresetIcon(customIcon, { tooltipTitle: tooltipTitle ? tooltipTitle : 'Detalhes', action, type: 'detail', ...otherProps });

const Default = ({ customIcon, tooltipTitle, action, ...otherProps }) =>
  PresetIcon(customIcon, { tooltipTitle, action, type: 'default', ...otherProps });

const TipIcon = ({ tip, icon }) => <Tooltip title={tip}>{icon}</Tooltip>;

export default {
  ...AntIcons,
  ...CustomIcons,
  Font,
  MDI,
  Add,
  Edit,
  Delete,
  Detail,
  Default,
  Selected,
  TipIcon,
};
